module.exports = __webpack_public_path__ + "img/p6.4ede8365.png";